import { render, staticRenderFns } from "./kds.vue?vue&type=template&id=0668c1af&scoped=true"
import script from "./kds.vue?vue&type=script&lang=js"
export * from "./kds.vue?vue&type=script&lang=js"
import style0 from "./kds.vue?vue&type=style&index=0&id=0668c1af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0668c1af",
  null
  
)

export default component.exports